export const categoryList = [
  {
    id: 1,
    value: 'place',
    label: '🏠 House',
  },
  {
    id: 2,
    value: 'dish',
    label: '🏢 Flats',
  },
];

export const ratingList = [
  {
    id: 1,
    value: '1',
    label: '1🌟',
  },
  {
    id: 2,
    value: '2',
    label: '2🌟',
  },
  {
    id: 3,
    value: '3',
    label: '3🌟',
  },
  {
    id: 4,
    value: '4',
    label: '4🌟',
  },
  {
    id: 5,
    value: '5',
    label: '5🌟',
  },
];

export const dataList = [
  {
    id: 1,
    title: 'House 01',
    serviceTime: '3 Rooms',
    rooms: '3',
    bathroom: '2 ',
    square: '455m',
    address: '#65 Borivali Mumbai',
    deliveryFee: 3.44,
    category: 'place',
    cuisine: 'mumbai',
    rating: 5,
    price: 2500,
    coverSrc: '/images/house/house01.jpg',
  },
  {
    id: 2,
    title: 'House 02',
    serviceTime: '15-20min',
    rooms: '1',
    bathroom: '1 ',
    square: '100m',
    address: '#778 New Town Banglore',
    deliveryFee: 4.94,
    category: 'place',
    cuisine: 'bangalore',
    rating: 4,
    price: 1000,
    coverSrc: '/images/house/house02.jpg',
  },
  {
    id: 3,
    title: 'House 03',
    serviceTime: '30-22min',
    rooms: '2',
    bathroom: '1 ',
    square: '300m',
    address: '#7 Patel Nagar , New Delhi',
    deliveryFee: 4.94,
    category: 'place',
    cuisine: 'delhi',
    rating: 3,
    price: 2000,
    coverSrc: '/images/house/house03.jpg',
  },
  {
    id: 4,
    title: 'House 04',
    rooms: '3',
    bathroom: '1 ',
    square: '800m',
    address: '#1287 Dombivalli Mumbai',
    serviceTime: '10-18min',
    deliveryFee: 2.14,
    category: 'place',
    cuisine: 'mumbai',
    rating: 1,
    price: 1800,
    coverSrc: '/images/house/house04.jpg',
  },
  {
    id: 5,
    title: 'House 05',
    rooms: '2',
    bathroom: '1 ',
    square: '100m',
    address: '#01 Balaji Nagar Banglore',
    serviceTime: '25-30min',
    deliveryFee: 6.79,
    category: 'place',
    cuisine: 'bangalore',
    rating: 5,
    price: 2000,
    coverSrc: '/images/house/house05.jpg',
  },
  {
    id: 6,
    title: 'House 06',
    rooms: '2',
    bathroom: '2 ',
    square: '350m',
    address: '#445 Saket , New Delhi',
    serviceTime: '5-15min',
    deliveryFee: 2.87,
    category: 'place',
    cuisine: 'delhi',
    rating: 5,
    price: 3500,
    coverSrc: '/images/house/house06.jpg',
  },
  {
    id: 7,
    title: 'Flat 01',
    rooms: '1',
    bathroom: '1 ',
    square: '455m',
    address: '#666 shivaji palace Mumbai',
    serviceTime: '50-65min',
    deliveryFee: 8.5,
    category: 'dish',
    cuisine: 'mumbai',
    rating: 2,
    price: 2200,
    coverSrc: '/images/Flats/flat01.jpg',
  },
  {
    id: 8,
    title: 'Flat 02',
    rooms: '1',
    bathroom: '1 ',
    square: '100m',
    address: '#99 Rustom Nagar Banglore',
    serviceTime: '10-15min',
    deliveryFee: 1.8,
    category: 'dish',
    cuisine: 'mumbai',
    rating: 1,
    price: 1900,
    coverSrc: '/images/Flats/flat02.jpg',
  },
  {
    id: 9,
    title: 'Flat 03',
    serviceTime: '12-18min',
    rooms: '4',
    bathroom: '4 ',
    square: '1250m',
    address: '#4478 Vasant Kunj New Delhi',
    deliveryFee: 3.33,
    category: 'dish',
    cuisine: 'delhi',
    rating: 4,
    price: 2750,
    coverSrc: '/images/Flats/flat03.jpg',
  },
  {
    id: 10,
    title: 'Flat 04',
    serviceTime: '30-38min',
    rooms: '1',
    bathroom: '1 ',
    square: '45m',
    address: '#7896 Nehru palace Mumbai',
    deliveryFee: 1.9,
    category: 'dish',
    cuisine: 'mumbai',
    rating: 2,
    price: 4350,
    coverSrc: '/images/Flats/flat04.jpg',
  },
  {
    id: 11,
    title: 'Flat 05',
    rooms: '5',
    bathroom: '3 ',
    square: '24560m',
    address: '#9978/2 Rustom Nagar Banglore',
    serviceTime: '16-20min',
    deliveryFee: 4.1,
    category: 'dish',
    cuisine: 'bangalore',
    rating: 3,
    price: 3300,
    coverSrc: '/images/Flats/flat05.jpg',
  },
  {
    id: 12,
    title: 'Flat 06',
    rooms: '2',
    bathroom: '2 ',
    square: '350m',
    address: '#445 Saket , New Delhi',
    serviceTime: '24-30min',
    deliveryFee: 1.5,
    category: 'dish',
    cuisine: 'delhi',
    rating: 2,
    price: 4100,
    coverSrc: '/images/Flats/flat06.jpg',
  },
];
